<template lang="">
    <div class="general">
        <div class="left">
            <div class="place">
                {{place}}
            </div>
            <div class="title">
                {{title}}
            </div>
        </div>
        <div class="right">
            <div class="dates" v-if="start != null">
                {{start}} - {{end}}
            </div>
            <div class="dates" v-else>
               {{end}}
            </div>
            <div class="dates location">
                {{location}}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        place: {
            type: String,
            },
        title:  {
            type: String,
            },
        start:  {
            type: String,
            },
        end:  {
            type: String,
            },
        location:{
            type: String,
        }
        
    }
}
</script>
<style scoped>
    .general{
        display: flex;
        justify-content: space-between;
        margin-bottom:0.4rem;
    }

    .place{
        color:var(--tertiary);
        font-weight: bold;
    }

    .title{
        font-weight: bold;
    }

    .dates{
        font-weight: bold;
        font-size: 0.8rem;
        color:black;
        
    }

    .right{
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
    }

    @media (max-width:768px) {
         .place{
            font-size: 0.8rem;
            white-space: nowrap;
            overflow-x: hidden;
            text-overflow: ellipsis;
            max-width:12rem;
         }

    .title{
        font-size: 0.7rem;
        white-space: nowrap;
        overflow-x: hidden;
        text-overflow: ellipsis;
        max-width:12rem;
    }

    .location{
        white-space: nowrap;
        overflow-x: hidden;
        text-overflow: ellipsis;
        max-width:6rem;
    }

    .dates{
        font-size: 0.7rem;
        
    }



   

    .general{
        
        margin-bottom:0.1rem;
    }
    }
</style>